import {PureComponent} from 'react'
import {Field, reduxForm} from 'redux-form'
import Plus from 'react-feather/dist/icons/plus.js'

import Select from '../../Form/Field/Select.jsx'
import validate from './validate.js'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import conf from '../../../conf.js'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import LanguageTypeahead from '../../Form/Field/LanguageTypeahead.jsx'

import CardCol from "../../../../shared/components/Styled/Card/CardCol.jsx"
import CardRow from "../../../../shared/components/Styled/Card/CardRow.jsx"

import './LanguageForm.scss'

export const name = 'LanguageForm'

class LanguageForm extends PureComponent {
  constructor(props) {
    super(props)
    this.props.initialize({level: conf.languageLevels.native.value})
  }

  handleSubmit = (values) => {
    const subResult = this.props.handleSubmit(values)
    if (!subResult.then) {
      return subResult
    }
    return subResult
      .then((data) => {
        this.props.reset()
        return data
      })

  }

  render() {
    return (
      <div id={name} className="language-form">
        <form autoComplete="off" onSubmit={this.handleSubmit}>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
          <CardRow align="flex-end" gap="20px">
            <CardCol flex={1}  className="formations-form-field-col">
              <Field
                label="Langue"
                name="language"
                placeholder="Entrez le nom d'une langue"
                component={LanguageTypeahead}/>
            </CardCol>

            <CardCol flex={1}  className="formations-form-field-col">
              <Field
                label="Niveau"
                name="level"
                type="text"
                component={Select}>
                {Object.values(conf.languageLevels).map((level) => (
                  <option value={level.value} key={level.value}>{level.label}</option>
                ))}
              </Field>
            </CardCol>

            <CardCol>
              <button type="submit" className="mb-3 btn btn-outline-primary">
                <Plus/> Ajouter
              </button>
            </CardCol>
          </CardRow>

        </form>
      </div>
    )
  }
}

export default reduxForm({
  form: name,
  validate,
  onSubmitFail: createOnSubmitFailHandler(name)
})(LanguageForm)